import { callApi, callApiFile } from './service'

const GetPeriods = async (lang) => {
	return callApi(`/Statement/GetPeriods?companyId=${sessionStorage["rp_company"]}&lang=${lang}`, 'GET')
		.then((result) => {
			return result;
		});
};

const GetStatmentPdf = async (periodo) => {
	return callApi(`/Statement/GetPdf?companyId=${sessionStorage["rp_company"]}&periodo=${periodo}`, 'GET')
		.then((result) => {
			return result;
		});
};

export const statmentService = {
	GetPeriods,
	GetStatmentPdf
};